import React from "react";


const VARIANT = {
  bordered: "border border-gray-400",
  v1: "!border-none"

}
const CookEInput = ({
  label,
  className,
  LabelFrontIcon,
  endIcon,
  name,
  required,
  variant = "v1",
  ...intrinsicProps
}) => {

  const inputClassName = `!bg-white !rounded-xl !outline-none !text-gray-900 !placeholder-gray-400 !focus:border-none !w-full !py-2.5 !focus:outline-none !focus:ring-orange-200 !focus:ring-4 !placeholder:text-gray-1000 ${VARIANT[variant]} ${className}`;
  return (
    <div>
      {label && <label
        className="block dark:text-white text-black text-sm font-medium mb-1"
        htmlFor={name}
      >
        {label} {required && <span className="text-red-600">*</span>}
      </label>}
      <input className={inputClassName} name={name} required={required} {...intrinsicProps} />
    </div>
  );
};

export default CookEInput;
